import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, vModelText as _vModelText, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-3 mb-20" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "col-md-3 mb-3" }
const _hoisted_7 = { class: "col-md-3 mb-20" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = {
  class: "position-relative mt-2 p-2 bg-white shadow rounded",
  style: {"z-index":"999"}
}
const _hoisted_10 = { class: "col-md-3 mb-3 mt-3" }
const _hoisted_11 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_12 = { class: "p-15 p-md-20 border-bottom d-flex flex-wrap align-items-center justify-content-between gap-2" }
const _hoisted_13 = { class: "d-flex align-items-center flex-wrap gap-2" }
const _hoisted_14 = { class: "d-flex align-items-center gap-1" }
const _hoisted_15 = { class: "mb-0 text-nowrap" }
const _hoisted_16 = { class: "position-relative" }
const _hoisted_17 = { class: "p-15 p-md-20" }
const _hoisted_18 = {
  key: 0,
  class: "text-nowrap"
}
const _hoisted_19 = {
  key: 1,
  class: "text-nowrap"
}
const _hoisted_20 = {
  key: 2,
  class: "text-nowrap"
}
const _hoisted_21 = {
  key: 3,
  class: "text-nowrap"
}
const _hoisted_22 = {
  key: 4,
  class: "text-nowrap"
}
const _hoisted_23 = {
  key: 0,
  class: "badge rounded-pill fs-13 text-bg-danger"
}
const _hoisted_24 = {
  key: 1,
  class: "badge rounded-pill fs-13 text-bg-info"
}
const _hoisted_25 = {
  key: 2,
  class: "badge rounded-pill fs-13 text-bg-success"
}
const _hoisted_26 = {
  key: 6,
  class: "dropdown"
}
const _hoisted_27 = { class: "dropdown-menu" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { key: 1 }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { key: 2 }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { key: 3 }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { key: 7 }
const _hoisted_37 = {
  key: 0,
  class: "row mb-30"
}
const _hoisted_38 = {
  class: "col-md-12",
  style: {"margin-left":"15px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_MyDateRangePicker = _resolveComponent("MyDateRangePicker")!
  const _component_feather_icon = _resolveComponent("feather-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_center = _resolveComponent("center")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_PaginatorContent = _resolveComponent("PaginatorContent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[13] || (_cache[13] = _createElementVNode("label", null, "Zone:", -1)),
              _createVNode(_component_v_select, {
                class: "custom-select-height",
                label: "name",
                options: _ctx.ZonesList,
                modelValue: _ctx.zone_filter,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.zone_filter) = $event))
              }, null, 8, ["options", "modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[15] || (_cache[15] = _createElementVNode("label", null, "Statut", -1)),
            _withDirectives(_createElementVNode("select", {
              class: "form-control",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.status_filter) = $event))
            }, _cache[14] || (_cache[14] = [
              _createElementVNode("option", { value: "" }, "Statut (Tous)", -1),
              _createElementVNode("option", { value: 0 }, "Nouveau", -1),
              _createElementVNode("option", { value: 1 }, "Enregistré", -1),
              _createElementVNode("option", { value: 2 }, "Payé", -1)
            ]), 512), [
              [_vModelSelect, _ctx.status_filter]
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _cache[17] || (_cache[17] = _createElementVNode("label", null, "Par Date :", -1)),
              _createElementVNode("div", {
                class: "border p-2 cursor-pointer",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showCalendar()))
              }, [
                _createTextVNode(_toDisplayString(_ctx.selectedDate?.[0]?.format("DD MMM YYYY") || "—") + " - " + _toDisplayString(_ctx.selectedDate?.[1]?.format("DD MMM YYYY") || "—") + " ", 1),
                _cache[16] || (_cache[16] = _createElementVNode("i", { class: "flaticon-calendar float-end" }, null, -1))
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_9, [
                _createVNode(_component_MyDateRangePicker, {
                  modelValue: _ctx.selectedDate,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedDate) = $event)),
                  onOnSelect: _ctx.showCalendar,
                  enableSecondCalendar: true
                }, null, 8, ["modelValue", "onOnSelect"])
              ], 512), [
                [_vShow, _ctx.showCalendarBox]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              class: "btn btn-primary me-2",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)))
            }, [
              _createVNode(_component_feather_icon, {
                icon: "FilterIcon",
                size: "16"
              }),
              _cache[18] || (_cache[18] = _createTextVNode(" Filtrer ", -1))
            ]),
            _createElementVNode("button", {
              class: "btn btn-outline-danger",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.resetFilters && _ctx.resetFilters(...args)))
            }, [
              _createVNode(_component_feather_icon, {
                icon: "XIcon",
                size: "16"
              }),
              _cache[19] || (_cache[19] = _createTextVNode(" Annuler ", -1))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _cache[20] || (_cache[20] = _createElementVNode("label", { class: "mb-0 text-nowrap" }, "Voir", -1)),
            _createVNode(_component_v_select, {
              modelValue: _ctx.users.per_page,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.users.per_page) = $event)),
              options: [10, 25, 50],
              clearable: false,
              class: "per-page-selector d-inline-block",
              style: {"min-width":"75px"},
              onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getRecords()))
            }, null, 8, ["modelValue"]),
            _createElementVNode("label", _hoisted_15, "sur " + _toDisplayString(_ctx.users.total) + " entités", 1)
          ]),
          (_ctx.auth.can('ADD_BP_Z'))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.AutoAdd && _ctx.AutoAdd(...args))),
                class: "btn btn-sm btn-success"
              }, _cache[21] || (_cache[21] = [
                _createElementVNode("i", { class: "flaticon-plus me-1" }, null, -1),
                _createTextVNode(" Auto-Ajout Bon pour Zone ", -1)
              ])))
            : _createCommentVNode("", true),
          (_ctx.auth.can('ADD_BP_Z'))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                class: "btn btn-sm btn-primary",
                to: { name: 'NewPaymentZonePage' }
              }, {
                default: _withCtx(() => _cache[22] || (_cache[22] = [
                  _createElementVNode("i", { class: "flaticon-plus me-1" }, null, -1),
                  _createTextVNode(" Ajouter Bon pour Zone ", -1)
                ])),
                _: 1,
                __: [22]
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.users.searchTerm) = $event)),
            type: "text",
            class: "form-control form-control-sm rounded-1 ps-4",
            style: {"min-width":"260px"},
            placeholder: "Rechercher...",
            onInput: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
          }, null, 544), [
            [_vModelText, _ctx.users.searchTerm]
          ]),
          _cache[23] || (_cache[23] = _createElementVNode("i", {
            class: "flaticon-search position-absolute top-50 translate-middle-y ms-2",
            style: {"left":"0","opacity":"0.4","pointer-events":"none"}
          }, null, -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_vue_good_table, {
          columns: _ctx.columns,
          rows: _ctx.rows,
          responsive: "",
          "select-options": {
        selectOnCheckboxOnly: true,
        enabled: true,
        clearSelectionText: 'Annuler',
        selectionText: 'Bons Sélectionés',
        disableSelectInfo: true,
      },
          onSelectedRowsChange: _ctx.selectPays,
          onSelectAll: _ctx.onSelectAllPays
        }, {
          emptystate: _withCtx(() => [
            _createVNode(_component_center, null, {
              default: _withCtx(() => _cache[24] || (_cache[24] = [
                _createTextVNode("Aucune entrées correspondants trouvés", -1)
              ])),
              _: 1,
              __: [24]
            })
          ]),
          "table-row": _withCtx((props) => [
            (props.column.field === 'pay_z_ref')
              ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                  _createElementVNode("b", null, _toDisplayString(props.row.pay_z_ref), 1)
                ]))
              : (props.column.field === 'zone_name')
                ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                    _createTextVNode(_toDisplayString(props.row.zone_name), 1),
                    _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1)),
                    _createTextVNode(" " + _toDisplayString(props.row.agency_name), 1)
                  ]))
                : (props.column.field === 'created_at')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                      (props.row.created_at != null)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_ctx.getDate(props.row.created_at)), 1),
                            _cache[26] || (_cache[26] = _createElementVNode("br", null, null, -1))
                          ], 64))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(props.row.by_name), 1)
                    ]))
                  : (props.column.field === 'paid_time')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                        (props.row.paid_time != null)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(_ctx.getDate(props.row.paid_time)), 1),
                              _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1))
                            ], 64))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(props.row.paid_by_name), 1)
                      ]))
                    : (props.column.field === 'total')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(props.row.total) + " DH ", 1))
                      : (props.column.field === 'statut')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                            (props.row.statut == 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_23, " Nouveau "))
                              : (props.row.statut == 1)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_24, " Enregistré "))
                                : (props.row.statut == 2)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_25, " Payé "))
                                  : _createCommentVNode("", true)
                          ], 64))
                        : (props.column.field === 'action')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                              _cache[33] || (_cache[33] = _createElementVNode("button", {
                                class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                                type: "button",
                                "data-bs-toggle": "dropdown",
                                "aria-expanded": "false"
                              }, [
                                _createElementVNode("i", { class: "flaticon-dots" })
                              ], -1)),
                              _createElementVNode("ul", _hoisted_27, [
                                _createElementVNode("li", null, [
                                  _createVNode(_component_router_link, {
                                    class: "dropdown-item",
                                    to: {
                    path: `/edit-payment-zone/${props.row.id}/${props.row.pay_z_ref}`,
                  }
                                  }, {
                                    default: _withCtx(() => _cache[28] || (_cache[28] = [
                                      _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1),
                                      _createTextVNode(" Détails ", -1)
                                    ])),
                                    _: 2,
                                    __: [28]
                                  }, 1032, ["to"])
                                ]),
                                (
                  props.row.statut == 0 &&
                  props.row.num_bns == 0 &&
                  _ctx.auth.can('BP_Z')
                )
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_28, [
                                      _createElementVNode("button", {
                                        class: "dropdown-item",
                                        onClick: ($event: any) => (_ctx.RemoveNote(props.row))
                                      }, _cache[29] || (_cache[29] = [
                                        _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1),
                                        _createTextVNode(" Supprimer ", -1)
                                      ]), 8, _hoisted_29)
                                    ]))
                                  : _createCommentVNode("", true),
                                (
                  props.row.statut == 0 &&
                  props.row.num_bns != 0 &&
                  _ctx.auth.can('BP_Z')
                )
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_30, [
                                      _createElementVNode("button", {
                                        class: "dropdown-item",
                                        onClick: ($event: any) => (_ctx.SaveBon(props.row))
                                      }, _cache[30] || (_cache[30] = [
                                        _createElementVNode("i", { class: "flaticon-diskette lh-1 me-8 position-relative top-1" }, null, -1),
                                        _createTextVNode(" Enregistrer ", -1)
                                      ]), 8, _hoisted_31)
                                    ]))
                                  : _createCommentVNode("", true),
                                (
                  props.row.statut == 1 &&
                  props.row.num_bns != 0 &&
                  _ctx.auth.can('BP_Z')
                )
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_32, [
                                      _createElementVNode("button", {
                                        class: "dropdown-item",
                                        onClick: ($event: any) => (_ctx.OpenBon(props.row))
                                      }, _cache[31] || (_cache[31] = [
                                        _createElementVNode("i", { class: "flaticon-unlock lh-1 me-8 position-relative top-1" }, null, -1),
                                        _createTextVNode(" Ouvrir ", -1)
                                      ]), 8, _hoisted_33)
                                    ]))
                                  : _createCommentVNode("", true),
                                (
                  props.row.statut == 1 &&
                  props.row.num_bns != 0 &&
                  _ctx.auth.can('BP_Z')
                )
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_34, [
                                      _createElementVNode("button", {
                                        class: "dropdown-item",
                                        onClick: ($event: any) => (_ctx.BonPaid(props.row))
                                      }, _cache[32] || (_cache[32] = [
                                        _createElementVNode("i", { class: "flaticon-check lh-1 me-8 position-relative top-1" }, null, -1),
                                        _createTextVNode(" Changer En Payé ", -1)
                                      ]), 8, _hoisted_35)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(props.formattedRow[props.column.field]), 1))
          ]),
          _: 1
        }, 8, ["columns", "rows", "onSelectedRowsChange", "onSelectAll"]),
        _createVNode(_component_PaginatorContent, {
          pagination: _ctx.users,
          offset: 9,
          onPaginate: _ctx.getRecords
        }, null, 8, ["pagination", "onPaginate"]),
        (_ctx.rows && _ctx.rows.length != 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("button", {
                  class: "btn btn-success",
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.SaveNotes && _ctx.SaveNotes(...args)))
                }, "Enregistrer"),
                _createElementVNode("button", {
                  class: "btn btn-info",
                  onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.PaidNotes && _ctx.PaidNotes(...args)))
                }, "Payer")
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}